<template>
  <v-layout dark>
    <v-container v-if="error.statusCode === isNotFound">
      <div class="detail-container">
        <div class="place-holder">
          <h1 class="text--secondary mb-10">
            {{ t('errors.view.page.not-found.title') }}
          </h1>
          <span class="text-body-1 text--secondary">{{
            t('errors.view.page.not-found.description-1')
          }}</span>
          <span class="text-body-1 text--secondary">{{
            t('errors.view.page.not-found.description-2')
          }}</span>
          <NuxtLink to="/">
            <v-btn class="mt-12" color="primary" size="large">
              {{ t('button.home') }}
            </v-btn>
          </NuxtLink>
        </div>
      </div>
    </v-container>
    <!-- 404以外 -->
    <v-container v-else>
      <h1>{{ t('errors.view.page.unknown.title') }}</h1>
      <NuxtLink to="/">
        {{ t('errors.view.page.unknown.description-1') }}
      </NuxtLink>
    </v-container>
  </v-layout>
</template>

<script setup lang="ts">
import { HTTP_STATUS } from '@/constants/common';
import { definePageMeta, useHead, useI18n } from '#imports';

definePageMeta({
  layout: 'empty',
});
const props = defineProps<{
  error: { statusCode: number };
}>();

const isNotFound = HTTP_STATUS.STATUS_CODE.NOT_FOUND;
const { t } = useI18n();
const title =
  props.error.statusCode === isNotFound
    ? t('errors.view.page.not-found.head')
    : t('errors.view.page.unknown.head');
useHead({
  title,
});
</script>

<style lang="scss" scoped>
h1 {
  font-size: 20px;
}

.place-holder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 192px;

  h1 {
    font-size: 60px;
  }
}

.detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
}
</style>
